
import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {
    BASE_URL,
    GET_CARE_PLAN_INFO,
} from "../../../env";
import {
    getRecords,
    isSuccess,
    toastSuccessMessages,
    catchAsync,
} from "../../../helper/helper";
import ProgressComponent from "../../../components/general/ProgressComponent";

function InfoModalPopup({ modalPopupTitle }) {
    const carePlanInfoTitle = modalPopupTitle;
    // console.log("🚀 ~ InfoModalPopup ~ modalPopupTitle:", modalPopupTitle)
    const [carePlanInfoData, setCarePlanInfoData] = useState("")
    const apiQuery = {
        query: {
            critarion: {}
        },
        sortproperty: "createdAt",
        sortorder: -1
    };


    const [isLoading, setIsLoading] = useState(true);



    // Getting records from DB
    const processFetchRecords = (method, data) => {
        if (method === "get" && data?.status === isSuccess) {
            const carePlanInforamtionData = data?.data?.carePlanInformation?.filter((item) => item.title === carePlanInfoTitle);
            // console.log("🚀 ~ processFetchRecords ~ carePlanInforamtionData:", carePlanInforamtionData)
            setCarePlanInfoData(carePlanInforamtionData)
            setIsLoading(false);
        }
    };

    const fetchAllRecords = catchAsync(async (req, res) => {
        const response = await getRecords(GET_CARE_PLAN_INFO, apiQuery);
        processFetchRecords("get", response);
    });

    useEffect(() => {
        fetchAllRecords();
    }, []);

    return (
        <>
            <div className="carePlanInfoData">
                {isLoading ? (
                    <ProgressComponent />
                ) : (
                    carePlanInfoData?.map((item, index) => (
                        <div
                            key={index}
                            dangerouslySetInnerHTML={{ __html: item.description }}
                        />
                    ))
                )}
            </div>
        </>
    );
}

export default InfoModalPopup